import { Text, Image, Container, Stack, SimpleGrid, Box } from "@chakra-ui/react";
import YCLogo from "../assets/companies/YCLogo.png";
import AudienceRepublicLogo from "../assets/companies/AudienceRepublicLogo.png";
import OptimumBrewLogo from "../assets/companies/OptimumBrew.svg";
import RyvnLogo from "../assets/companies/ryvnLogo.png";
import KlookLogo from "../assets/companies/KlookLogo.png";
import RampLogo from "../assets/companies/RampYellow.svg";
import INDMoneyLogo from "../assets/companies/INDmoney.png";


const data = [
    { logo: YCLogo, brightness: 1, isText: false },
    { logo: RampLogo, brightness: 1, isText: false },
    { text: "Top 10 US\nHedge Fund", isText: true },
    { logo: INDMoneyLogo, brightness: 1, invert: true, isText: false },
    { logo: KlookLogo, brightness: 1, isText: false },
    { logo: AudienceRepublicLogo, brightness: 1, isText: false },
    { logo: OptimumBrewLogo, brightness: 1, isText: false },
    { logo: RyvnLogo, isText: false },
];

export default function Users() {
    return (
        <Container maxWidth={"5xl"} px={4} mt={"3rem"} mb={"3rem"} centerContent>
            <Stack alignItems="center" width="100%" overflow="hidden">
                <Text
                    fontSize={{ base: "2xl", md: "3xl" }}
                    textAlign="center"
                    mb={8}
                    px={2}
                >
                    Trusted by developers from
                </Text>
                <SimpleGrid
                    columns={{ base: 3, md: 4 }}
                    spacing={{ base: 10, md: 12 }}
                    justifyItems="center"
                    alignItems="center"
                    px={2}
                    mx="auto"
                    width="100%"
                    maxWidth="800px"
                >
                    {data.map((item, index) => (
                        item.isText ? (
                            <Box
                                key={index}
                                textAlign="center"
                                fontWeight="bold"
                                fontSize={{ base: "md", md: "lg" }}
                                width="150px"
                                height="70px"  // Increased from 60px to 70px
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                whiteSpace="pre-line"
                            >
                                {item.text}
                            </Box>
                        ) : (
                            <Image
                                key={index}
                                src={item.logo}
                                alt="Company logo"
                                width="150px"
                                height="60px"
                                objectFit="contain"
                                userSelect="none"
                                filter={item.invert ? "invert(1)" : "none"}
                                transition="filter 0.1s"
                                margin="0 auto"
                                display="block"
                            />
                        )
                    ))}
                </SimpleGrid>
            </Stack>
        </Container>
    );
}
